module.exports = __webpack_public_path__ + "26f696d678cece5ed5608360c3c591d9.svg";